
export const API_PARTIDOS = 'https://gmatchapp.com/api/v1/partidos';
export const TIME_API_PARTIDOS = 5000;

export const SPORT_TYPES = [
    'padel',
    'tenis',
    'pingpong',
    'pingPong'
]